module.exports = __webpack_public_path__ + "static/media/rating_5.fae2f221.svg";